var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var sortOnixItems = function (items) {
    return __spreadArray([], items, true).sort(function (a, b) { var _a, _b; return ((_a = a.value) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.value) !== null && _b !== void 0 ? _b : ""); });
};
var getOnixItems = function (source) { var _a; return Array.isArray(source) ? (source !== null && source !== void 0 ? source : []) : ((_a = source === null || source === void 0 ? void 0 : source.onixCodetableItems) !== null && _a !== void 0 ? _a : []); };
export var toSelectOptions = function (source) {
    return getOnixItems(source).map(function (i) {
        var _a, _b, _c;
        return ({
            value: (_a = i.value) !== null && _a !== void 0 ? _a : "",
            label: (_c = (_b = i.description) !== null && _b !== void 0 ? _b : i.value) !== null && _c !== void 0 ? _c : "",
        });
    });
};
export var findOnixItemByValue = function (source, value) {
    return getOnixItems(source).find(function (i) { return i.value === value; });
};
/** "Neurčeno" placeholder entries must never win as a default value. */
var isUndetermined = function (item) { var _a; return ((_a = item.description) !== null && _a !== void 0 ? _a : "").trim().toLowerCase() === "neurčeno"; };
/**
 * Default codetable item: first by ONIX code order, skipping the
 * "Neurčeno" placeholder (falls back to it only when nothing else exists).
 */
export var firstOnix = function (source) {
    var _a;
    var items = sortOnixItems(getOnixItems(source));
    return (_a = items.find(function (item) { return !isUndetermined(item); })) !== null && _a !== void 0 ? _a : items[0];
};
var compareCodepoints = function (a, b) {
    if (a === void 0) { a = ""; }
    if (b === void 0) { b = ""; }
    if (a === b)
        return 0;
    return a < b ? -1 : 1;
};
/**
 * The display (picker) order of codetable items, i.e. the order of
 * `/onix-codetable-items?query=… sortBy sortOrder value id`: sortOrder
 * ascending with missing values last, then value, then id. The items nested in
 * a codetable are ordered by sortOrder only, and most items have none, so the
 * rest of the order has to be restored with this comparator.
 *
 * @param a first codetable item
 * @param b second codetable item
 * @return negative when a goes first, positive when b goes first, 0 when equal
 */
export var compareOnixCodetableItems = function (a, b) {
    if (a.sortOrder != null && b.sortOrder != null) {
        if (a.sortOrder !== b.sortOrder)
            return a.sortOrder - b.sortOrder;
    }
    else if (a.sortOrder != null) {
        return -1;
    }
    else if (b.sortOrder != null) {
        return 1;
    }
    return compareCodepoints(a.value, b.value) || compareCodepoints(a.id, b.id);
};
/**
 * Default codetable item: first in the codetable's display order
 * ({@link compareOnixCodetableItems} — sortOrder, then ONIX code), skipping the
 * "Neurčeno" placeholder (falls back to it only when nothing else exists).
 * Unlike {@link firstOnix}, the codetable's sortOrder wins over the ONIX code,
 * so the default matches the first option the picker offers.
 *
 * @param source codetable wrapper or raw item array
 * @return the first displayed item, or undefined when the source is empty
 */
export var firstByDisplayOrder = function (source) {
    var _a;
    var items = __spreadArray([], getOnixItems(source), true).sort(compareOnixCodetableItems);
    return (_a = items.find(function (item) { return !isUndetermined(item); })) !== null && _a !== void 0 ? _a : items[0];
};
/**
 * Default codetable item selected by ONIX code (never by array index, which
 * depends on the codetable's sort_order). Returns the item matching the first
 * of the given preferred codes that exists in the source; falls back to
 * {@link firstOnix} when none of the preferred codes is present.
 *
 * @param source codetable wrapper or raw item array
 * @param preferredCodes ONIX codes to try, in priority order
 * @return the preferred item, the firstOnix fallback, or undefined when empty
 */
export var preferredOnix = function (source) {
    var preferredCodes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        preferredCodes[_i - 1] = arguments[_i];
    }
    var items = getOnixItems(source);
    var _loop_1 = function (code) {
        var match = items.find(function (item) { return item.value === code; });
        if (match)
            return { value: match };
    };
    for (var _a = 0, preferredCodes_1 = preferredCodes; _a < preferredCodes_1.length; _a++) {
        var code = preferredCodes_1[_a];
        var state_1 = _loop_1(code);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return firstOnix(source);
};
/** ONIX Publishing status (codetable 64) code for "Neurčeno" (unspecified). */
export var UNSPECIFIED_PUBLISHING_STATUS = "00";
/** ONIX Publishing status (codetable 64) code for "Zrušeno" (cancelled). */
export var CANCELLED_PUBLISHING_STATUS = "01";
/**
 * Default ONIX Publishing status (codetable 64) for a freshly created product.
 * A new product must never default to "Zrušeno" (cancelled, code 01): prefer
 * "Neurčeno" (code 00); otherwise take the first non-cancelled item in the
 * codetable's order; only if nothing else exists fall back to the first item.
 *
 * Shared by both product-create paths (full-page ProductCreate and the
 * "Vytvořit produkt + přidělit číslo" modal) so their defaults cannot drift
 * apart again. Deliberately not {@link firstOnix}, which would return code 01.
 *
 * @param source codetable wrapper or raw item array
 * @return the default publishing-status item, or undefined when the source is empty
 */
export var defaultPublishingStatus = function (source) {
    var _a, _b;
    var items = getOnixItems(source);
    return ((_b = (_a = items.find(function (item) { return item.value === UNSPECIFIED_PUBLISHING_STATUS; })) !== null && _a !== void 0 ? _a : items.find(function (item) { return item.value !== CANCELLED_PUBLISHING_STATUS; })) !== null && _b !== void 0 ? _b : items[0]);
};
/**
 * Returns a copy of the items with the entries matching the given ONIX codes
 * moved to the front, in the order listed; the remaining items keep their
 * original order. Use to surface the most frequently used options at the top of
 * a picker without dropping or hiding any option.
 *
 * @param items the (already filtered) codetable items
 * @param preferredCodes ONIX codes to hoist to the top, in the desired order
 * @return a new array with preferred items first, followed by the rest
 */
export var withPreferredFirst = function (items, preferredCodes) {
    var preferred = preferredCodes
        .map(function (code) { return items.find(function (item) { return item.value === code; }); })
        .filter(function (item) { return item !== undefined; });
    var rest = items.filter(function (item) { var _a; return !preferredCodes.includes((_a = item.value) !== null && _a !== void 0 ? _a : ""); });
    return __spreadArray(__spreadArray([], preferred, true), rest, true);
};
